// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"ki-z","itemsContainer":"li-z"};